import { Stack, Box } from "@chakra-ui/layout";
import { Checkpoint } from "components";

export const ProductMastheadCheckpoints = ({
  items,
  color,
}: {
  items: string[];
  color;
}) => {
  return (
    <Box my={4}>
      {items.map((item: string, index: number) => {
        return <Checkpoint label={item} color={color} key={index} />;
      })}
    </Box>
  );
};
